import BaseContainer from "@base/container/BaseContainer"
import BackgroundContainer from "./BackgroundContainer"
import * as PIXI from "pixi.js";
import ScaleManager from "@/stage/ScaleManager"
import Facade from "@/Facade";
import {Signals} from "@/Imports"
import GameBackgroundContainer from "@/containers/GameBackgroundContainer";
import PlaneContainer1 from "@/containers/PlaneContauner1";
import MultiplierContainer from "@/containers/MultiplierContainer";
import MakeBetsContainer from "@/containers/MakeBetsContainer";
import CurtainContainer from "@/containers/CurtainContainer";
import Config from "@/config/Config";
import Utils from "@base/utils/Utils";
import PlatformContainer from "./PlatformContainer";
import PlaneContainer from "@/containers/PlaneContainer";
import MultipliersHistoryContainer from "@/containers/MultipliersHistoryContainer";
import GameBackgroundUpperContainer from "@/containers/GameBackgroundUpperContainer";
import FeatureContainer from "@/containers/FeatureContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import DangerousAnimationBgContainer from "@/containers/DangerousAnimationBgContainer";
import LineAnimatedBackgroundContainer from "@/containers/LineAnimatedBackgroundContainer";
import RewardContainer from "@/containers/RewardContainer";

export default class MainContainer extends BaseContainer {

  constructor() {
    super()
    this.isCreated = false
    Facade.mainContainer = this
    this.init()
    this.interactive = false

    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.chatVisibilityChange.add(this.onChatVisibilityChange, this)

    Signals.roundEnd.add(this.onStopFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.startFeature.add(this.onStartFeature, this)
    Signals.makeBets.add(this.onMakeBets, this)
  }

  init() {
    this.onOrientationChanged(Facade.orientation)

    this.generalContainer = new PIXI.Container()
    this.addChild(this.generalContainer)

    this.gameBackground = new GameBackgroundContainer()
    this.generalContainer.addChild(this.gameBackground)

    this.danger = new SpineAnimation('warningSignAnim')
    this.addChild(this.danger)
    Utils.applyFromPattern(this.danger, Config.currentPattern.planeContainer)
    this.danger.x -= 400
    this.danger.visible = false

    this.featureContainer = new FeatureContainer()
    this.generalContainer.addChild(this.featureContainer)

    this.dangerousAnimationBackground = new DangerousAnimationBgContainer()
    this.generalContainer.addChild(this.dangerousAnimationBackground)

    this.planeContainer = new PlaneContainer()
    this.generalContainer.addChild(this.planeContainer)

    this.gameUpperBackground = new GameBackgroundUpperContainer()
    this.generalContainer.addChild(this.gameUpperBackground)

    this.multiplierContainerShadow = new MultiplierContainer({style:'multiplierShadow'})
    this.generalContainer.addChild(this.multiplierContainerShadow)

    this.multiplierContainer = new MultiplierContainer()
    this.generalContainer.addChild(this.multiplierContainer)

    //this.multipliersHistoryContainer = new MultipliersHistoryContainer()
    //this.addChild(this.multipliersHistoryContainer)

    this.makeBetsContainer = new MakeBetsContainer()
    this.generalContainer.addChild(this.makeBetsContainer)

    this.curtainContainer = new CurtainContainer()
    this.generalContainer.addChild(this.curtainContainer)

    this.rewardContainer = new RewardContainer()
    this.generalContainer.addChild(this.rewardContainer)

    window.dispatchEvent(new Event('resize'))

    Signals.graphicsCreated.dispatch()

    this.setPositions()

    this.isCreated = true

  }

  onStopFeature() {
    this.danger.visible = false
    this.danger.stop()
  }

  onStartFeature() {
    this.danger.visible = true
    this.danger.start(['warningSignAnim'], [true])
  }

  onMakeBets() {
  }

  onContinueBtnClick() {
    Signals.chatVisibilityChange.dispatch(true)
  }

  onChatVisibilityChange(visible) {
    Facade.rootDIV = document.getElementById('root')
    Facade.rootDIV.style.visibility = visible ? "visible" : "hidden"
  }

  onOrientationChanged(orientationSymbol) {
    Config.currentPattern = Config.pattern.desktop
    /*
    switch (orientationSymbol) {
      case 'Hd':
        Config.currentPattern = Config.pattern.desktop
        break

      case 'Hm':
        Config.currentPattern = Config.pattern.landscape
        break

      case 'Vm':
        Config.currentPattern = Config.pattern.portrait
        break
    }
     */
    if(this.isCreated) {
      this.setPositions()
    }
  }

  setPositions() {

    Utils.applyFromPattern(this.gameBackground, Config.currentPattern.mainMask)
    Utils.applyFromPattern(this.gameUpperBackground, Config.currentPattern.mainMask)
    Utils.applyFromPattern(this.dangerousAnimationBackground, Config.currentPattern.mainMask)
    Utils.applyFromPattern(this.featureContainer, Config.currentPattern.main)
    Utils.applyFromPattern(this.planeContainer, Config.currentPattern.planeContainer)
    Utils.applyFromPattern(this.makeBetsContainer, Config.currentPattern.makeBetsContainer)
    Utils.applyFromPattern(this.curtainContainer, Config.currentPattern.main)

    Utils.applyFromPattern(this.multiplierContainer, Config.currentPattern.multiplierContainer)

    this.curtainContainer.y -= 220
    this.gameUpperBackground.y += 30

    this.multiplierContainer.y += 80
    this.multiplierContainer.x += 100
    this.multiplierContainerShadow.x = this.multiplierContainer.x + 3
    this.multiplierContainerShadow.y = this.multiplierContainer.y + 3

    this.makeBetsContainer.x += 45
    this.planeContainer.y += 24

    this.featureContainer.y += 20

    this.rewardContainer.x = ScaleManager.currentSizes.total.width / 2
    this.rewardContainer.y = ScaleManager.currentSizes.total.height / 2

    this.generalContainer.visible = true

  }

}
